import { CookieIcon } from '~components/icons'
import { Box } from '@mui/material'
import { COLORS } from '~theme/colors'
import useBreakpoint from '~hooks/use-breakpoint'
import { breakpointsWithHamburgerMenu } from '~components/navigation-and-footer/navigation/navigation-context'

export function CookieBannerOpener({
  onClickHandler,
}: {
  onClickHandler: () => void
}) {
  const { breakpoint } = useBreakpoint(true)
  const isHamburger = breakpointsWithHamburgerMenu.includes(breakpoint)

  return (
    <Box
      sx={{
        position: isHamburger ? 'absolute' : 'initial',
        left: 0,
        color: COLORS.primary.white,
        bgcolor: 'transparent',
        border: 'none',
        '&: hover': { color: COLORS.primary.maerskBlue },
      }}
      aria-label="Open cookie settings"
      component="button"
      onClick={onClickHandler}
    >
      <CookieIcon
        height={isHamburger ? '24px' : '32px'}
        width={isHamburger ? '24px' : '32px'}
      />
    </Box>
  )
}
